export enum RouteFragmentEnum {
    LOGOUT = 'logout',
    LOGIN = 'login',
    SUCCESS = 'success',
    ERROR = 'error',
    FINES = 'fines',
    DRIVER = 'driver',
    OBJECTION = 'objection',
    CREATE = 'create',
    SELECTION = 'selection',
    OTHER_DRIVER_DETAILS = 'other-driver-details',
    OTHER_DRIVER_ARGUMENTATION = 'other-driver-argumentation',
    OTHER_DRIVER_ARGUMENTATION_FILES = 'other-driver-argumentation-files',
    OTHER_DRIVER_PRIVACY = 'other-driver-privacy',
    OTHER_DRIVER_SUMMARY = 'other-driver-summary',
    DRIVER_CHANGE_DRIVER = 'driver-change-driver',
    DRIVER_CHANGE_COMPANY = 'driver-change-company',
    // Unused after the DEV-3389 company-step removal. Kept intentionally — it
    // will likely be needed again when GAS4 is implemented. Do not remove.
    DRIVER_CHANGE_NATIONALITY = 'driver-change-nationality',
    DRIVER_CHANGE_DRIVER_DETAILS = 'driver-change-driver-details',
    DRIVER_CHANGE_DETAILS = 'driver-change-details',
    DRIVER_CHANGE_FILES = 'driver-change-files',
    DRIVER_CHANGE_PRIVACY = 'driver-change-privacy',
    DRIVER_CHANGE_SUMMARY = 'driver-change-summary',
}
